import { categoriesSortBySlug } from './constants';

export const sortCategories = categories => categories
  .sort((a, b) => categoriesSortBySlug.indexOf(a.slug) - categoriesSortBySlug.indexOf(b.slug));
